import { memo } from 'react';
import { COLUMN_TYPE } from '../../../../../../constants/generalConstants';
import {
    useCellMetadata,
    useColumnContentType,
    useIsColumnImportCandidate,
    useIsRowImportCandidate,
    useRowContentType,
} from '../../../../../../stores/metadataStore';
import { RowIdType, TableBlockRowCellType, TableModeType } from '../../../../../../types';
import { getAnnotationTableCellStyling } from './utils';
import { ImageHighlighterWrapper } from '../../../../../imageHighlighter/imageHighlighter';
import ImagePopup from '../../../../../imagePopup';
import CellDataContainer from '../cellDataContainer';

type AnnotationsTableCellPropsType = {
    cell: TableBlockRowCellType;
    mode: TableModeType;
    rowId: RowIdType;
};
const AnnotationsTableCell = memo(function AnnotationsTableCell({ cell, mode, rowId }: AnnotationsTableCellPropsType) {
    const colContentType = useColumnContentType(cell.collId);
    const rowContentType = useRowContentType(rowId)!;
    const cellMetadata = useCellMetadata(cell.id);
    const isRowImportCandidate = useIsRowImportCandidate(rowId);
    const isColumnImportCandidate = useIsColumnImportCandidate(cell.collId);

    const importCandidate = !!isRowImportCandidate && !!isColumnImportCandidate;
    const { styles, classes } = getAnnotationTableCellStyling(mode, cell, rowContentType, cellMetadata, importCandidate);
    const cellValue = cell.data.value;
    return (
        <td key={cell.id} style={styles} className={classes}>
            <ImageHighlighterWrapper boundingBox={cell.boundingBox}>
                <CellDataContainer>
                    {colContentType !== COLUMN_TYPE.FIELD_NAMES ? (
                        <ImagePopup coordinates={cell.boundingBox} trigger={<span className={'ml-auto'}>{cellValue}</span>} />
                    ) : (
                        <span>{cellValue}</span>
                    )}
                </CellDataContainer>
            </ImageHighlighterWrapper>
        </td>
    );
});

export default AnnotationsTableCell;
